import { memo, useMemo, useRef } from "react"
import { useSelector } from "react-redux"
import { selectOrderBookTopAsk, selectOrderBookTopBid } from "../../../../selectors/security"
import { Typography } from "@mui/material"
import { Security } from "../../../../proto/generated/security"
import { getSecurityKey } from "../../../../util/security"

export const RenderBid = memo(({ security, handleOrderClick, rowKey, strike, initialValue, type, illiquid }: {
    security: Security | undefined
    initialValue: number
    handleOrderClick?: (type: "buy" | "sell" | undefined, strike: number, callput: "call" | "put") => Promise<void>
    rowKey: string
    strike: number
    type: 'put' | 'call'
    illiquid?: boolean
}) => {
    const securityKey = getSecurityKey(security?.exchange ?? 0, security?.code ?? '')
    const topBid = useSelector(selectOrderBookTopBid(securityKey))
    const initialRendered = useRef(false)
    const topBidValue = useMemo(() => {
        if (topBid === undefined && !initialRendered.current) {
            return initialValue
        } else {
            initialRendered.current = true
            return topBid
        }
    }, [initialValue, topBid])

    return (
        <Typography sx={{ color: (theme) => theme.palette.text.secondary }}
            className="text-right font-feature-num"
            style={{ cursor: 'pointer', fontSize: '14px', height: '33px', padding:"0px !important" }}
            onClick={() => handleOrderClick?.('sell', strike, type)}
            data-event={`Option Chain ${type.toUpperCase()} Sell Clicked`}
            data-event-strike={security?.strikePrice}
        ><span
        // className={`${type}-bid`}
        >{(!topBidValue || topBidValue===0) ? '-' : ((topBidValue ?? 0) / (security?.priceMultiplier ?? 100))?.toFixed(2)}</span></Typography>
    )
})

export const RenderAsk = memo(({ security, handleOrderClick, rowKey, strike, initialValue, type, illiquid }: {
    security: Security | undefined
    initialValue: number
    handleOrderClick?: (type: "buy" | "sell" | undefined, strike: number, callput: "call" | "put") => Promise<void>
    rowKey: string
    strike: number
    type: 'put' | 'call'
    illiquid?: boolean
}) => {
    const securityKey = getSecurityKey(security?.exchange ?? 0, security?.code ?? '')
    const topAsk = useSelector(selectOrderBookTopAsk(securityKey))
    const initialRendered = useRef(false)
    const topAskValue = useMemo(() => {
        if (topAsk === undefined && !initialRendered.current) {
            return initialValue
        } else {
            initialRendered.current = true
            return topAsk
        }
    }, [initialValue, topAsk])

    return (
        <Typography sx={{ color: (theme) => theme.palette.text.secondary }}
            className="text-right buy-order right-row font-feature-num"
            style={{ cursor: 'pointer', fontSize: '14px', height: '33px', padding:'0px !important' }}
            onClick={() => handleOrderClick?.('buy', strike, type)}
            data-event={`Option Chain ${type.toUpperCase()} Buy Clicked`}
            data-event-strike={security?.strikePrice}
        >
            <span
            // className={`${type}-ask`}
            >{(!topAskValue || topAskValue===0) ? '-' : ((topAskValue ?? 0) / (security?.priceMultiplier ?? 100))?.toFixed(2)}</span></Typography>
    )
})